/** @format */

import type React from "react";
import { type FC, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import InfiniteScroll from "react-infinite-scroller";
import styled from "styled-components";
import { usePrevious } from "../../../hooks/usePrevious";
import theme from "../../../styles/theme";
import Box from "../../atoms/box/Box";
import Typography from "../../atoms/typography/Typography";
import type { ListProps } from "./List.types";

const ListEnd = styled.div`
  width: auto;
  margin: 24px;
  height: 200px;
`;
const ListEndText = styled.div`
  text-align: center;
  animation: 2s opacityAfter50PercentAnimation;
`;
const List: FC<ListProps> = ({
  listType,
  loading,
  CardType,
  dropdown,
  data,
  organization,
  ideasData,
  project,
  handle,
  user,
  firebaseUser,
  listEndText,
  className,
  variant,
  ...props
}) => {
  const dataLength = data?.length;
  const { t } = useTranslation();
  const prevdataLength = usePrevious({ dataLength });
  const prevDropdown = usePrevious({ dropdown });

  useEffect(() => {
    if (
      (dataLength &&
        prevdataLength &&
        prevdataLength.dataLength !== dataLength) ||
      (dropdown && prevDropdown && prevDropdown.dropdown !== dropdown)
    ) {
      // const element = document.getElementById("List");

      // element?.scrollTo({
      //   top: 0,
      //   left: 0,
      // });

      setListItems(1);
      sethasMoreItems(true);
    }
  }, [loading, dropdown, dataLength]);

  const itemsPerPage = 1;
  const [hasMoreItems, sethasMoreItems] = useState(true);
  const [listItems, setListItems] = useState(0);

  const showItems = (dataArray, CardType) => {
    const items: React.ReactNode[] = [];
    if (dataArray?.length !== 0) {
      for (let i = 0; i < listItems; i++) {
        // Skip rendering if data is undefined, null, or doesn't have required properties
        if (!dataArray[i] || typeof dataArray[i] !== "object") {
          continue;
        }

        items.push(
          <Box
            key={`List.tsx-${i}`}
            /* key={dataArray[i].commentId ||
              dataArray[i].ideaId ||
              dataArray[i].projectId ||
              dataArray[i].organizationId} */
            margin="16px 0px 0px 0px"
            display={listType === "grid" ? "contents" : "flex"}
            flexDirection={listType === "grid" ? "row" : "column"}
          >
            <CardType
              data={dataArray[i]}
              organization={organization}
              project={project}
              ideasData={ideasData}
              handle={handle}
              user={user}
              variant={variant}
              {...props}
            />
          </Box>,
        );
      }
      return items;
    }
  };
  const loadMore = useCallback(() => {
    if (listItems === data?.length) {
      sethasMoreItems(false);
    } else {
      setTimeout(() => {
        setListItems(listItems + itemsPerPage);
      }, 50);
    }
  }, [listItems, data?.length]);

  return (
    <>
      {data && data.length > 0 && (
        <InfiniteScroll
          id="List"
          loadMore={() => loadMore()}
          hasMore={hasMoreItems}
          useWindow={false}
          className={className}
        >
          {showItems(data, CardType)}
        </InfiniteScroll>
      )}

      {listEndText && (data?.length < 1 || !hasMoreItems) && (
        <ListEnd>
          <ListEndText>
            <Typography
              variant="h3"
              textAlign="center"
              color={theme.colors.black.black60tra}
            >
              {listEndText}
            </Typography>
          </ListEndText>
        </ListEnd>
      )}
    </>
  );
};

export default List;
